import AiChat from './AiChat'

export default AiChat
